import React from "react";
import { Grid } from "@mui/material";
import { DateField } from "@curves/ui-base";
import { FieldGroup } from "@icoach/documents/components/Layout";
import { EmployeeSelect, ReadTextField } from "@icoach/components";
import { getErrorModuleStatus } from "@util/utils";
import { parseDate } from "@util/moment";
import { useMembershipSuspensionFormContext } from "@icoach/documents/membership/suspension/MembershipSuspensionFormContext";

const MembershipSuspensionFormInfoSection = () => {
	const {
		formData,
		formRef,
		options,
		validationErrors,
		isReadOnly,
		handleChangeApplyDate,
	} = useMembershipSuspensionFormContext();

	const { applyDate, employeeID, unusedMonth, unusedDay, usedMonth, usedDay } = formData;
	const { coachOptions } = options;

	return (
		<>
			<FieldGroup label="表單資訊">
				<Grid item xs={4}>
					<DateField
						label="申請日期"
						ref={el => (formRef.current.applyDate = el)}
						defaultValue={parseDate(applyDate)}
						{...getErrorModuleStatus(validationErrors, "applyDate")}
						readOnly={isReadOnly}
						required
						fullWidth
						onChange={handleChangeApplyDate}
					/>
				</Grid>
				<Grid item xs={4}>
					<EmployeeSelect
						ref={el => (formRef.current.employeeID = el)}
						options={coachOptions}
						label="經辦教練"
						defaultValue={employeeID}
						{...getErrorModuleStatus(validationErrors, "employeeID")}
						readOnly={isReadOnly}
						displayEmpty
						required
						fullWidth
					/>
				</Grid>
			</FieldGroup>

			<FieldGroup label="暫停資訊">
				<Grid item xs={6}>
					<ReadTextField label="待停扣月數">{unusedMonth}</ReadTextField>
				</Grid>
				<Grid item xs={6}>
					<ReadTextField label="待停扣天數">{unusedDay}</ReadTextField>
				</Grid>
				<Grid item xs={6}>
					<ReadTextField label="已停扣月數">{usedMonth}</ReadTextField>
				</Grid>
				<Grid item xs={6}>
					<ReadTextField label="已停扣天數">{usedDay}</ReadTextField>
				</Grid>
			</FieldGroup>
		</>
	);
};

export default MembershipSuspensionFormInfoSection;